<div class="hmhs-dynamic-form mat-typography mat-body mat-app-background" [ngClass]="{ 'review-only': formConfig.form.customConfigs?.reviewOnly }">

  @if (!formConfig.form.customConfigs?.reviewOnly) {
    <!-- Form Page Heading -->
    @if (formConfig.pages[currentPage]?.showPageHeader) {
      <h1 class="form-heading">
      {{formConfig.pages[currentPage]?.pageHeader}}</h1>
    }
  }

  <!-- Form Entries Loop -->
  <div #reviewPage>
    @if (reviewConfigReady) {
      @for (entry of formConfig.pages[currentPage]?.entries; track entry; let i = $index) {
        <div class="form-row"
          [ngClass]="{ 'hide-entry': entry.base?.foreverHidden }">
          @switch (entry?.custom?.reviewMode) {
            @case ('editable') {
              <ptl-entry-as-json [entryConfig]="entry" [form]="pageFormGroups" [formConfig]="formConfig">
              </ptl-entry-as-json>
              <!-- <button>Edit</button>*ngIf="!queAns.hideEditButton && !isViewPlan"  -->
            }
            @case ('entryReviewTemplate') {
              <ptl-entry-as-json [entryConfig]="entry.custom.reviewEntryConfig" [form]="pageFormGroups"
                [formConfig]="formConfig" [reviewOnly]="formConfig.form.customConfigs?.reviewOnly == true">
              </ptl-entry-as-json>
            }
            @default {
              @if (retrieveEntry(entry, true)) {
                <h4><strong>{{entry?.formControlAttributes?.label}}</strong></h4>
                <p>
                  {{ retrieveEntry(entry) || "Review" }}
                </p>
                @if (!formConfig.form.customConfigs?.reviewOnly) {
                  <button mat-raised-button
                  class="edit-button" color="secondary" (click)="editQuestion(entry)">Edit</button>
                }
              }
            }
          }
        </div>
      }
    }
  </div>

  <!-- Form Page Nav BUTTONS -->
  @if (!formConfig.form.customConfigs?.reviewOnly) {
    <div class="form-buttons">
      @if (formConfig.form.formNavigation.saveButton.display) {
        <div class="save-later"
          [ngClass]="{'disable-link' : isSubmitting }">
          <a href="javascript:void(0)" (click)="saveForLaterButton()">
            <span class="text">SAVE FOR LATER</span>
            <span class="material-symbols-outlined save-icon">save</span>
          </a>
        </div>
      }
      <div class="navigational-controls">
        @if (formConfig.form.formNavigation.backButton.display && currentPage !== 0) {
          <div class="nav-link"
            [ngClass]="{'disable-link' : isSubmitting }">
            <a href="javascript:void(0)" (click)="backButton()">
              <span class="material-symbols-outlined">arrow_back</span>
              <span class="text left-text">BACK</span>
            </a>
          </div>
        }
        @if (formConfig.form.formNavigation.nextButton.display && currentPage !== formConfig.pages.length - 1) {
          <div class="nav-link spacer" [ngClass]="{'disable-link' : isSubmitting }"
            >
            <a href="javascript:void(0)" (click)="nextButton()">
              <span class="text">NEXT</span>
              <span class="material-symbols-outlined">arrow_forward</span>
            </a>
          </div>
        }
      </div>
      @if (currentPage === formConfig.pages.length - 1) {
        <button mat-raised-button color="primary" class="submit-button"
          [disabled]="isSubmitting" (click)="submitButton()">
          SUBMIT
        </button>
      }
    </div>
  }
</div>